import { routes as adminApiRoutes } from './admin-api'
import { routes as authApiRoutes } from './auth-api'

export const routes = { ...adminApiRoutes, ...authApiRoutes }
